import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// A single-page site doesn't reset the scroll position on navigation.
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
